/* rr-swatch.js (29 Sept 2026): colours for the product card swatches that
   XCloud renders itself (search results, /a/search, XCloud collection
   grids). Its cards still use the Flex v6 markup
   (a.swatch > span[style="background-color: rr"] > img.swatch__image--empty
   alt="Red - RR"): the colour is the value's last word, so our values with a
   supplier code ("Red - RR") came out invalid, and Flex v7 no longer ships the
   styles that hid the "no image" placeholder. This reads the colour words from
   the value name, the same table as snippets/rr-swatch-color.liquid (keep the
   two in step), and paints one colour, a split swatch for "Red / White / Blue",
   or the variant photo when no colour word is known. Availability is never
   shown on a card swatch (owner, 29 Sept). */
(function () {
  'use strict';
  var FULL = {
    'dark red': '#8B1A1A', 'deep red': '#8B1A1A', 'wine': '#8B1A1A',
    'bright red': '#E4002B', 'candy red': '#E4002B',
    'bright blue': '#3A8DDE', 'light blue': '#3A8DDE', 'sky blue': '#3A8DDE',
    'dark blue': '#1F2F5C', 'navy': '#1F2F5C', 'navy blue': '#1F2F5C', 'midnight blue': '#1F2F5C',
    'blue gray': '#667788', 'slate': '#667788', 'slate gray': '#667788',
    'dark gray': '#4A4D50', 'charcoal': '#4A4D50', 'graphite': '#4A4D50', 'gunmetal': '#4A4D50', 'gun metal': '#4A4D50', 'dark gunmetal': '#4A4D50',
    'light gray': '#C4C6C8', 'cool gray': '#C4C6C8',
    'dark green': '#4B5320', 'forest green': '#4B5320', 'olive': '#4B5320', 'od green': '#4B5320', 'olive drab': '#4B5320',
    'lime green': '#6DBD4E', 'neon green': '#6DBD4E', 'raptor green': '#6DBD4E',
    'burgundy': '#7A1F2B', 'maroon': '#7A1F2B',
    'carbon fiber': '#2B2B2B', 'carbon': '#2B2B2B',
    'chrome': '#C9CCCE', 'polished': '#C9CCCE', 'aluminum': '#C9CCCE', 'raw aluminum': '#C9CCCE', 'brushed aluminum': '#C9CCCE',
    'tan': '#C8AD7F', 'sand': '#C8AD7F', 'desert tan': '#C8AD7F', 'khaki': '#C8AD7F', 'coyote': '#C8AD7F', 'coyote tan': '#C8AD7F',
    'teal': '#128A8A', 'turquoise': '#128A8A',
    'clear': '#FFFFFF'
  };
  var BASE = {
    black: '#000000', white: '#FFFFFF', red: '#F61F1F', blue: '#005BD3', gray: '#808080',
    silver: '#D3D3D3', gold: '#D49A06', green: '#05AA3D', yellow: '#FFE500', orange: '#FF8A00',
    pink: '#FFC0CB', purple: '#A54DCF', brown: '#9A5630', bronze: '#CD7F32', beige: '#EAD8AB'
  };
  function one(p) {
    p = p.replace(/grey/g, 'gray').replace(/\b(matte|gloss|satin|metallic|textured)\s+/g, '').replace(/\s+/g, ' ').trim();
    if (!p) return '';
    if (FULL[p]) return FULL[p];
    if (BASE[p]) return BASE[p];
    var w = p.split(' ');
    return BASE[w[w.length - 1]] || '';
  }
  function paint(name) {
    var base = String(name || '').split(' - ')[0].toLowerCase().replace(/&/g, '/').replace(/ and /g, '/').replace(/,/g, '/');
    var parts = base.split('/').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!parts.length || parts.length > 4) return null;
    var cols = [];
    for (var i = 0; i < parts.length; i++) {
      var c = one(parts[i]);
      if (!c) return null;
      cols.push(c);
    }
    if (cols.length === 1) return { color: cols[0] };
    var step = 100 / cols.length;
    var g = cols.map(function (c, k) { return c + ' ' + (k * step).toFixed(2) + '% ' + ((k + 1) * step).toFixed(2) + '%'; });
    return { image: 'linear-gradient(135deg, ' + g.join(', ') + ')' };
  }
  function fix(root) {
    var spans = (root || document).querySelectorAll('.thumbnail-swatch a.swatch > span:not([data-rr-sw])');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      s.setAttribute('data-rr-sw', '1');
      var img = s.querySelector('img');
      var name = (img && img.getAttribute('alt')) || (s.parentNode.getAttribute('data-swatch-name') || '').replace(/^meta-color_/, '').replace(/_/g, ' ');
      var hasImage = img && !/no-image/.test(img.getAttribute('src') || '');
      if (hasImage) continue;   /* a real swatch image: leave it */
      var p = paint(name);
      if (p && p.color) {
        s.style.backgroundColor = p.color;
      } else if (p && p.image) {
        s.style.backgroundColor = '#FFFFFF';
        s.style.backgroundImage = p.image;
      } else if (s.getAttribute('data-image')) {
        s.style.backgroundColor = '#FFFFFF';
        s.style.backgroundImage = 'url("' + s.getAttribute('data-image') + '")';
      }
    }
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; fix(document); });
  }
  function boot() {
    fix(document);
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].addedNodes && list[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
